import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";

var _templateObject;

import { gql } from '@apollo/client';
export var PLZN_SEARCH_SCHOOL = gql(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  query PlznSchools($query: String!, $limit: Int) {\n    plznSchools(query: $query, limit: $limit) {\n      city\n      id\n      institution\n      state\n    }\n  }\n"])));